import React from 'react';
import {Container} from '@material-ui/core';
import {FirebaseContext} from '../../Firebase';
import {Button, TextField} from '@material-ui/core';
import ReactGoogleSlides from 'react-google-slides';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

const Session11 = () => {
  const firebase = React.useContext(FirebaseContext);
  const group = firebase.userData.group;
  const [scr, setScr] = React.useState(0);
  const [CR, setCR] = React.useState(false);
  const [response, setResponse] = React.useState('');
  const [respMateriel, setRespMateriel] = React.useState('');
  return (
    <div>
      <Container
        style={{
          backgroundColor: 'lightblue',
          padding: '10px',
          minHeight: '270px',
        }}
      >
        {/* SCREENS INTRO ALL GROUP*/}
        {scr === 0 && (
          <div>
            <h3>Bienvenue dans cette nouvelle séance !</h3>
            <p>
              Est-ce que cela t’arrive de tenir la porte pour tes voisins, ou
              ramasser un déchet que tu trouves au sol ?
            </p>
            <p>
              Ces petits gestes de tous les jours, pour les autres et pour la
              planète, sont aussi des illustrations d’altruisme. Essayons d’en
              savoir plus.
            </p>
          </div>
        )}
        {scr === 1 && (
          <div style={{textAlign: 'center', width: '100%'}}>
            <ReactGoogleSlides
              width={'100%'}
              height={480}
              slidesLink="https://docs.google.com/presentation/d/11bAOxZXA7ATJ0tutRgcbSr9m6q2V8GoboWEDGaZLi4M"
              position={0}
              showControls
            />
            <br />
            <FormControl component="fieldset">
              <FormLabel component="legend">
                Le fait de faire moins de bruit est un moyen d’être solidaires
                avec ses voisins :
              </FormLabel>
              <RadioGroup
                aria-label="team"
                defaultValue=""
                name="radio-buttons-group-team"
                onChange={(e) => {
                  setCR(true);
                  setResponse(e.target.value);
                }}
              >
                <FormControlLabel value="oui" control={<Radio />} label="Oui" />
                <FormControlLabel value="non" control={<Radio />} label="Non" />
              </RadioGroup>
            </FormControl>
          </div>
        )}
        {/* SCREENS CONTROL*/}
        {group.toString() === 'control' && scr === 2 && (
          <div>
            <p>
              Tu as réfléchi au thème de ton spectacle, tu as répondu aux
              questions des élèves, maintenant il faut acheter tout le matériel
              nécessaire ! En route ?{' '}
            </p>
          </div>
        )}
        {group.toString() === 'control' && scr === 3 && (
          <div>
            <p>
              Les enseignants t’attribuent 20 jetons, qui vont te servir pour
              acheter le matériel pour fabriquer les décors et les costumes.
            </p>
            <p>
              A toi maintenant de décider combien de jetons tu vas attribuer à
              chaque élément. Tu peux décider en fonction de ce qui est le plus
              important à tes yeux.
            </p>
            <p>
              Par exemple, si le décor est le plus important, tu peux attribuer
              plus de jetons. Si ce sont les costumes qui importent, alors tu
              peux mettre plus de jetons pour acheter le matériel des costumes.
            </p>
            <p>
              Inscris ci-dessous le type de matériel (par exemple « plante », ou
              « armures ») puis indique combien de jeton tu paies pour cet
              élément (par exemple « plante - 2, armures - 6 »).
            </p>
            <TextField
              multiline
              fullWidth
              rows="8"
              id="regles"
              label="Matériel"
              variant="outlined"
              value={respMateriel}
              onChange={(e) => {
                setRespMateriel(e.target.value);
              }}
            />
            <p>Quand tu as terminé, clique sur le bouton ci-dessous.</p>
          </div>
        )}
        {group.toString() === 'control' && scr === 4 && (
          <div>
            <p>
              Nous avons terminé pour aujourd’hui. Rendez-vous à la prochaine
              session pour continuer l’organisation de ce spectacle. N’oublie
              pas de te connecter dans quelques jours pour la prochaine séance !
            </p>
            <p>Clique sur le bouton ci-dessous pour quitter la séance.</p>
          </div>
        )}
        {/* SCREENS TEST*/}
        {(group.toString() === 'test_a' ||
          group.toString() === 'test_b' ||
          group.toString() === 'test_c') &&
          scr === 2 && (
            <div>
              <p>
                Aujourd’hui, tu vas participer à l’achat de matériel pour une
                nouvelle action bénévole de ton groupe. Tu as réfléchi au thème
                de ton spectacle, tu as répondu aux questions des élèves,
                maintenant il faut acheter tout le matériel nécessaire ! En
                route ?
              </p>
            </div>
          )}
        {(group.toString() === 'test_a' ||
          group.toString() === 'test_b' ||
          group.toString() === 'test_c') &&
          scr === 3 && (
            <div>
              <p>
                Les responsables de l’association t’attribuent 20 jetons, qui
                vont te servir pour acheter le matériel d’une action bénévole.
              </p>

              <p>
                A toi maintenant de décider quelle action tu voudrais mener et
                combien de jetons tu vas attribuer à chaque élément dont tu as
                besoin. Tu peux décider en fonction de ce qui est le plus
                important à tes yeux.
              </p>
              {group.toString() === 'test_a' && (
                <div>
                  <p>
                    Par exemple, si tu voulais fabriquer des refuges à insectes,
                    tu peux attribuer des jetons au matériel dont tu as besoin.
                    Toutes tes idées sont les bienvenues !
                  </p>
                  <p>
                    Inscris ci-dessous le type de matériel (par exemple « bois
                    », ou « filets ») puis indique combien de jeton tu paies
                    pour cet élément (par exemple « bois - 2, filets - 6 »).
                  </p>
                </div>
              )}
              {group.toString() === 'test_b' && (
                <div>
                  <p>
                    Par exemple, si tu voulais fabriquer des livres avec les
                    patients, tu peux attribuer des jetons à ce dont tu as
                    besoin. Toutes tes idées sont les bienvenues !
                  </p>
                  <p>
                    Inscris ci-dessous le type de matériel (par exemple « papier
                    », ou « feutres ») puis indique combien de jeton tu paies
                    pour cet élément (par exemple « papier - 2, feutres - 6 »).
                  </p>
                </div>
              )}
              {group.toString() === 'test_c' && (
                <div>
                  <p>
                    Par exemple, si tu voulais récolter des produits d’hygiène
                    pour des personnes en situation de pauvreté, tu peux
                    attribuer des jetons à ce dont tu as besoin. Toutes tes
                    idées sont les bienvenues !
                  </p>
                  <p>
                    Inscris ci-dessous le type de matériel (par exemple « savon
                    », ou « serviettes ») puis indique combien de jeton tu paies
                    pour cet élément (par exemple « savon - 2, serviettes - 6
                    »).
                  </p>
                </div>
              )}
              <TextField
                multiline
                fullWidth
                rows="8"
                id="regles"
                label="Matériel"
                variant="outlined"
                value={respMateriel}
                onChange={(e) => {
                  setRespMateriel(e.target.value);
                }}
              />
              <p>Quand tu as terminé, clique sur le bouton ci-dessous.</p>
            </div>
          )}
        {(group.toString() === 'test_a' ||
          group.toString() === 'test_b' ||
          group.toString() === 'test_c') &&
          scr === 4 && (
            <div>
              <p>Nous avons terminé pour aujourd’hui.</p>
              <p>
                Rendez-vous à la prochaine session pour continuer l’organisation
                de ton action. N’oublie pas de te connecter dans quelques jours
                pour la prochaine séance !
              </p>
              <p>Clique sur le bouton ci-dessous pour quitter la séance.</p>
            </div>
          )}
      </Container>
      {/* BUTTON*/}
      <Button
        style={{display: 'block', margin: 'auto'}}
        disabled={scr === 1 && !CR}
        variant="contained"
        color="primary"
        onClick={() => {
          if (scr === 3) {
            // save TEST DATA
            let now = new Date();
            firebase
              .databehav(firebase.userData.pseudo)
              .collection('session11')
              .add({
                date: now,
                response: response,
                respMateriel: respMateriel,
              })
              .catch((error) => {
                console.log(error);
              });
          }
          if (scr === 4) {
            firebase.signoutUser();
          } else {
            setScr(scr + 1);
          }
        }}
      >
        Continuer
      </Button>
    </div>
  );
};
export default Session11;
